import { render, staticRenderFns } from "./CardMaterials.vue?vue&type=template&id=44cfc98a&scoped=true&"
import script from "./CardMaterials.vue?vue&type=script&lang=js&"
export * from "./CardMaterials.vue?vue&type=script&lang=js&"
import style0 from "./CardMaterials.vue?vue&type=style&index=0&id=44cfc98a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cfc98a",
  null
  
)

export default component.exports